import { useState } from "react";
import { useAuth } from "contexts/AuthContext";
import { Lock, Mail, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : err.message || "Login failed";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" data-testid="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-icon">R</div>
          <h1>RedTracker</h1>
          <p>Sign in to your dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form" data-testid="login-form">
          {error && <div className="login-error" data-testid="login-error">{error}</div>}
          <div className="login-field">
            <Mail size={16} />
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)}
              required data-testid="login-email" />
          </div>
          <div className="login-field">
            <Lock size={16} />
            <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)}
              required data-testid="login-password" />
          </div>
          <button type="submit" className="login-btn" disabled={loading} data-testid="login-submit">
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
